module.exports = __webpack_public_path__ + "img/icon_armazenamento_digital_repositorio_unico.1139970c.svg";